import ibanLib from 'iban';

import { SpanishBanks } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantCashInCashOutMethod/constants/SpanishBanks';

export const accountNumberValidation = ({ accountNumber, selectedBank }) => ({
  isValidIban: () => {
    const isValidIban = ibanLib.isValid(accountNumber);
    if (!isValidIban) return false;
    return true;
  },
  bankExistsInTable: () => {
    const accountNumberSupervisorCode = accountNumber.substring(4, 8);
    const bankExistsInTable = SpanishBanks.find((bank) => bank.supervisorCode === accountNumberSupervisorCode);
    if (!bankExistsInTable) return false;
    return true;
  },
  bankDoesNotMatchTheSelectedBank: () => {
    const accountNumberSupervisorCode = accountNumber.substring(4, 8);
    const selectedBankSupervisorCode = SpanishBanks.find((bank) => bank.value === selectedBank)?.supervisorCode;
    const bankExistsInTable = SpanishBanks.find((bank) => bank.supervisorCode === accountNumberSupervisorCode);
    if (bankExistsInTable?.supervisorCode !== selectedBankSupervisorCode) return false;
    return true;
  },
});
